import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { useRoute } from 'vue-router';
import { useLayoutStore } from '@/store';

import { ref, defineComponent, h, computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'KeepAliveRouterView',
  setup(__props) {
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const keepAlive = ref();
    function createComponent(name, component) {
      return defineComponent({
        name: name,
        render() {
          return component ? h(component) : null;
        }
      });
    }
    const keepAliveInclude = computed(() => {
      let tempList = [];
      layoutStore.tagList.filter(item => {
        const compomentName = item.compomentName;
        if (compomentName != null && tempList.indexOf(compomentName) === -1) {
          tempList.push(compomentName);
        }
      });
      return tempList;
    });
    const getRenderComponent = component => {
      const {
        name,
        query,
        fullPath
      } = route;
      if (route.meta.keepalive == null || !route.meta.keepalive) {
        return component;
      }
      let cacheKey = fullPath;
      let menuItem = layoutStore.currentMenu;
      let showName = query.__tagName || route.meta?.title || route.name;
      let currentMenu;
      // 判断当前路由是否是菜单路由，如果是菜单的路由使用菜单的名字，对于在线表单和报表formRouterName为空，其他的路由菜单则通过formRouterName来判断
      if (menuItem != null && menuItem.menuId != null && (menuItem.formRouterName === route.name || route.name === 'onlineForm' || route.name === 'reportRender')) {
        showName = menuItem.menuName;
        currentMenu = menuItem;
      }
      let tagItem = layoutStore.tagList.find(item => item.id === cacheKey);
      if (tagItem == null) {
        let tempComponent = createComponent(cacheKey, component);
        tagItem = {
          id: cacheKey,
          tagName: showName,
          routerName: route.name,
          compomentName: cacheKey,
          query: route.query,
          menuItem: currentMenu,
          component: tempComponent
        };
      } else if (tagItem.component == null || tagItem.component.render == null) {
        tagItem.component = createComponent(cacheKey, component);
      }
      if (tagItem.deleted !== true) {
        layoutStore.addTag(tagItem);
      }
      return tagItem.component;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "el-fade-in-linear",
          appear: true
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            ref_key: "keepAlive",
            ref: keepAlive,
            include: _unref(keepAliveInclude)
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(getRenderComponent(Component))))], 1032, ["include"]))]),
          _: 2
        }, 1024)]),
        _: 1
      });
    };
  }
});